import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload, IListSearchQueryPaginationPayload } from '@app-store/slices/rfqs/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}
interface TaskSearchAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure, onRequestSearch, onFailureSearch, onSuccessSearch } =
    rootActions.rfqs.companiesSearch

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query,
            'necessaryProjectionArray[]': ['brief', 'name']
        }

        const response = yield axios.get(`/search/companies`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* searchSagaTask({ payload }: TaskSearchAction) {
    try {
        const params = {
            textSearch: payload.textSearch,
            'necessaryProjectionArray[]': ['brief', 'name', 'logo']
        }

        const response = yield axios.get(`/search/companies`, {
            params
        })
        if (response.success) {
            yield put(onSuccessSearch(response.result))
        }
    } catch (error) {
        yield put(onFailureSearch(error))
    }
}

function* companiesSearchSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, listSagaTask),
        takeLatest<TaskSearchAction>(onRequestSearch, searchSagaTask)
    ])
}

export default companiesSearchSaga
